import { CSSProperties, MouseEventHandler } from "react";

interface IIconProps {
    name: string;
    size?: number;
    className?: string;
    onClick?: MouseEventHandler<HTMLElement>;
    style?: CSSProperties;
    title?: string;
}

export default function Icon({ name, size, className, onClick, style, title }: IIconProps) {
    const getTextSize = () => {
        switch (size) {
            case 1:
                return "xs";
            case 2:
                return "sm";
            case 3:
                return "base";
            case 4:
                return "lg";
            case 5:
                return "xl";
            case 6:
                return "2xl";
            case 7:
                return "3xl";
            default:
                return "base";
        }
    }

    return (
        <i onClick={onClick} title={title} style={style} className={`pi ${name} text-${getTextSize()} ${className}`}></i>
    )
}